<template lang="pug">
  .c-lst-port-dtl
    nuxt-link.c-lst-port-dtl-user(:to="`/${content.user.username || content.user.id}`")
      img(v-lazy="userImageUrl")
      span(v-html="highlight(content.user.nickname)")
    ul.c-lst-port-dtl-clip
      li(:class="{ liked: liked }" @click="onClickLikeButton")
        icon-heart-svg
        | {{ likeCount }}
      li(:class="{ clipped: clipped }" @click="onClickClipButton")
        icon-clip-svg
        | {{ clipCount }}
    sign-in-modal(
      :name="attribute"
      :description="description"
    )
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SignInModal from '~/components/SignInModal'
import IconHeartSvg from '~/assets/images/svg/icon_heart.svg?inline'
import IconClipSvg from '~/assets/images/svg/icon_clip.svg?inline'

export default {
  components: {
    SignInModal,
    IconHeartSvg,
    IconClipSvg
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      liked: false,
      clipped: false,
      likeCount: 0,
      clipCount: 0,
      attribute: '',
      description: ''
    }
  },
  watchQuery: true,
  computed: {
    ...mapGetters('search', ['query']),
    userImageUrl() {
      return (
        this.content.user.profile_image ||
        require('~/assets/images/user-130.png')
      )
    }
  },
  watch: {
    $route() {
      this.setPortfolioData()
    }
  },
  created() {
    this.setPortfolioData()
  },
  methods: {
    ...mapActions('portfolio', ['likeOn', 'likeOff', 'clipOn', 'clipOff']),
    highlight(text) {
      // TODO: 他でも共通で使うロジックなので共通化する
      if (this.query) {
        return text.replace(
          new RegExp(this.query.split(/[ 　]/).join('|'), 'ig'),
          (match) => {
            return '<span class="highlight">' + match + '</span>'
          }
        )
      } else {
        return text
      }
    },
    onClickLikeButton() {
      if (!this.$auth.user) {
        this.attribute = 'like'
        this.description = '記事を「いいね」する'
        this.$modal.show(this.attribute)
        return false
      }
      if (this.liked) {
        this.liked = false
        this.likeOff(this.content.id)
        this.likeCount--
      } else {
        this.liked = true
        this.likeOn(this.content.id)
        this.likeCount++
      }
    },
    onClickClipButton() {
      if (!this.$auth.user) {
        this.attribute = 'clip'
        this.description = '記事を「クリップ」する'
        this.$modal.show(this.attribute)
        return false
      }
      if (this.clipped) {
        this.clipped = false
        this.clipOff(this.content.id)
        this.clipCount--
      } else {
        this.clipped = true
        this.clipOn(this.content.id)
        this.clipCount++
      }
    },
    setPortfolioData() {
      this.liked = false
      this.clipped = false
      this.likeCount = this.content.likes_count
      this.clipCount = this.content.clips_count
      this.attribute = ''
      this.description = ''
      if (this.$auth.user) {
        if (this.content.liking_uids.includes(this.$auth.user.id)) {
          this.liked = true
        }
        if (this.content.clipping_uids.includes(this.$auth.user.id)) {
          this.clipped = true
        }
      }
    }
  }
}
</script>
